// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adsMain {
    display: flex;
    flex-direction: column;
    gap: 98px;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 50px 0 0 0;
}

.adsImage {
    width: 347.51px;
    height: 287.56px;
}

.adsColumn {
    display: flex;
    flex-direction: column;
    gap: 80px;
}

.adsEmptyText {
    color: #8E3B00;
    font-size: 19.27px;
    font-weight: 700;
    line-height: 23.12px;
    text-align: left;
    /* margin-top: -83px; */
    -webkit-user-select: none;
            user-select: none;
    width: 47%;
}`, "",{"version":3,"sources":["webpack://./src/components/Ads/Ads.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAiB;YAAjB,iBAAiB;IACjB,UAAU;AACd","sourcesContent":[".adsMain {\n    display: flex;\n    flex-direction: column;\n    gap: 98px;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    padding: 50px 0 0 0;\n}\n\n.adsImage {\n    width: 347.51px;\n    height: 287.56px;\n}\n\n.adsColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n}\n\n.adsEmptyText {\n    color: #8E3B00;\n    font-size: 19.27px;\n    font-weight: 700;\n    line-height: 23.12px;\n    text-align: left;\n    /* margin-top: -83px; */\n    user-select: none;\n    width: 47%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
